import React from "react";
import { Link } from "react-router-dom";
import "./SelfCheckup.css";

const SelfCheckup = () => {
  return (
    <section className="hero-section">
    <div style={{margin: "auto", maxWidth: "800px"}}>
          <>
          <h1>Self Checkup</h1>
        <br />
        <h2>10 health checks you can do at home</h2>
        <p>
          In an ideal world, everyone would have access to an affordable primary care
          system with a general practitioner, or family doctor, as their first point
          of contact and a range of impartial specialists and hospitals providing
          appropriate treatment.
        </p>
        <p>
          But in some countries, the health care system falls short. There might be a
          lack of primary care, treatment could be expensive, and aftercare could be
          unreliable.
        </p>
        <p>
          Virtual health is making primary care accessible to millions by giving
          patients remote access to doctors through a video interface on computers or
          mobile devices. Home checks such as those below could be used to support the
          diagnostic process.
        </p>
        <p>
          Whether or not you have access to virtual care, and wherever you live,
          there’s a lot you can do from home to monitor yours and your family's
          health. These 10 basic checks can help keep track of your health, monitor
          ongoing conditions and check symptoms. And if you do need to seek medical
          advice, you’ll have some useful information to pass on.
        </p>
        <h3>1. Take your temperature</h3>
        <p>
          Your body temperature can show if you might have a fever. Normal temperature
          for adults is around 37° C (98.6° F) but this will vary according to age,
          time of day and which part of the body you take the temperature from. Check
          it when you’re in good health so you know what’s normal for you. Invest in a
          good thermometer for the most accurate reading. This link provides
          additional information.
        </p>
        <p>
          Some wearable devices measure body temperature but may not be reliable. A
          high temperature can be worrying, especially in a child. If you’re
          concerned, seek medical advice either in person or via a virtual
          consultation.
        </p>
        <h3>2. Testicular checks</h3>
        <p>
          This is an essential check to discover lumps or swellings that could be an
          indication of cancer. It’s important to check regularly so you can recognise
          an abnormality.
        </p>
        <p>&nbsp;</p>
        <p>
          Check your testicles after a warm bath or shower, holding your scrotum in
          the palm of your hand and using the fingers and thumbs of both hands to
          examine your testes. You should consult a doctor if you feel an unusual lump
          or swelling, a sharp pain or a heavy scrotum.{" "}
          <a
            href="http://www.nhs.uk/chq/pages/878.aspx"
            aria-label="Get more information here, opens in new window"
            target="_blank"
          >
            Get more information here
          </a>
          .
        </p>
        <h3>3. Be breast aware</h3>
        <p>
          It’s important to be familiar with how your breasts look and feel at
          different points in your menstrual cycle. Breast changes can happen for many
          reasons, and most are not serious. Look out for changes in the outline or
          shape of the breast, for lumps, thickening or bumps, and for changes to the
          nipple or skin, as these could be a sign of cancer. It’s best to see a
          doctor as soon as possible if you notice any of these.{" "}
          <a
            href="https://www.nhs.uk/common-health-questions/womens-health/how-should-i-check-my-breasts/"
            aria-label="Click here for more information, opens in new window"
            target="_blank"
          >
            Click here for more information
          </a>
          .
        </p>
        <h3>4. Checking your heart rate</h3>
        <p>
          Your resting heart rate first thing in the morning gives an indication of
          your general wellness. What’s normal depends on your age and fitness — check
          every morning for a week to learn your usual pulse rate. You can check
          manually or with a heart rate monitor, fitness tracker or smartphone app.
        </p>
        <p>
          A change of 10 beats per minute (bpm) or more may mean you’re run down.
          Above 100 bpm could mean you’re stressed, dehydrated, excited or sick. If an
          elevated heart rate persists, consult a doctor.{" "}
          <a
            href="http://www.nhs.uk/chq/Pages/2024.aspx?CategoryID=52"
            aria-label="Click here for more detail, opens in new window"
            target="_blank"
          >
            Click here for more detail
          </a>
          .
        </p>
        <h3>5. Blood pressure</h3>
        <p>
          High blood pressure is a major risk factor for strokes, heart attack, heart
          failure and kidney disease. Often there are no warning symptoms so checking
          your blood pressure regularly is vital. Blood pressure monitors are
          straightforward to use; just make sure you’re in a calm environment when you
          do the test.
        </p>
        <p>
          Normal blood pressure in adults is between 90/60 and 120/80 mmHg. If your
          blood pressure is high, you can help by cutting salt and alcohol intake,
          eating healthily, exercising and keeping your weight down, but you should
          also seek medical advice.{" "}
          <a
            href="https://www.nhs.uk/common-health-questions/lifestyle/what-is-blood-pressure/"
            aria-label="Get more information here, opens in new window"
            target="_blank"
          >
            Get more information here
          </a>
          .
        </p>
        <h3>6. Blood and swab tests</h3>
        <p>
          You can save yourself trips to the doctor with a range of tests done at
          home; many promise more than 90% accuracy. Commonly used home blood tests
          can give an indication of cholesterol levels, thyroid issues, allergies and
          even HIV. Swab kits can reveal urinary tract infections and strep, the
          bacterial throat infection.
        </p>
        <p>
          Once you have your results, don’t just rely on Google to interpret them.
          Without the proper professional guidance, online advice can be misleading.
          If you get a positive result, consult a doctor.{" "}
          <a
            href="http://www.everydayhealth.com/healthy-living-pictures/new-home-tests-will-save-you-a-trip-to-the-doctor.aspx#01"
            aria-label="Click here for further information, opens in new window"
            target="_blank"
          >
            Click here for further information
          </a>
          .
        </p>
        <h3>7. Checking blood sugar levels</h3>
        <p>
          Diabetes can lead to complications such as heart, kidney and dental disease,
          stroke and blindness. You can buy home blood glucose tests (which involve
          fasting beforehand) but diabetes is a complicated condition and a home test
          is not enough by itself.
        </p>
        <p>
          If you have some of the common signs of diabetes (for example, increased
          thirst, increased hunger, dry mouth, blurred vision or headaches), consult a
          doctor. For those with access to a virtual care service, this can even be
          done remotely. If the doctor thinks you need further tests, they can arrange
          them for you.{" "}
          <a
            href="http://www.nhs.uk/Conditions/Diabetes-type2/Pages/Symptoms.aspx"
            aria-label="Click here for more details, opens in new window"
            target="_blank"
          >
            Click here for more details
          </a>
          .
        </p>
        <h3>8. Meningitis test</h3>
        <p>
          Meningitis is a frightening disease, especially in children, as it develops
          quickly and can be fatal. Spotting the symptoms yourself can save lives.
          Signs include flu-like symptoms as well as neck stiffness, drowsiness, an
          aversion to bright lights and sometimes a rash that doesn’t fade when you
          press the side of a clear glass firmly against the skin. But don’t wait
          until a rash develops – get medical help immediately if you suspect
          meningitis. There are also phone apps that can help you spot meningitis so
          you don’t have to remember the symptoms.{" "}
          <a
            href="https://www.nhs.uk/conditions/meningitis/symptoms/"
            aria-label="Click here for more information, opens in new window"
            target="_blank"
          >
            Click here for more information
          </a>
          .
        </p>
        <h3>9. Waist fat measurement</h3>
        <p>
          It’s important to stay at a healthy weight but you should also ensure you
          don’t carry too much fat around your waist. This can increase the risk of
          cardiovascular disease, insulin resistance and type 2 diabetes.
        </p>
        <p>
          Measure your waist at the level of your belly button. Regardless of your
          height or BMI, you should try to lose weight if your waist is 94cm (37ins)
          or more for men and 80cm (31.5ins) or more for women. Your health care
          provider may offer a weight reduction programme.{" "}
          <a
            href="http://www.nhs.uk/chq/Pages/849.aspx"
            aria-label="http://www.nhs.uk/chq/Pages/849.aspx, opens in new window"
            target="_blank"
          >
            Get more information here
          </a>
          .
        </p>
        <h3>10. Skin check</h3>
        <p>
          Skin cancer is one of the most common forms of cancer but you can screen
          yourself quite easily. Check yourself once a month, looking for new growths
          or moles that have changed or started to bleed, itch, burn or crust over.
          Speak to a doctor if you find these.
        </p>
        <p>
          If you’re fair-skinned, have lots of moles or have spent a lot of time in
          the sun, you’re more at risk and should consider getting a dermatologist to
          check you once a year.{" "}
          <a
            href="http://www.nhs.uk/Conditions/Malignant-melanoma/Pages/Introduction.aspx#Signs"
            aria-label="Click here for further detail, opens in new window"
            target="_blank"
          >
            Click here for further detail
          </a>
          .
        </p>
        <br />
      </>
    </div>
  </section>
  
  );
};

export default SelfCheckup;